import _ from "underscore";
import $ from "jquery";

import Keyword from '../models/keyword';

import Collection from "backdraft-app/src/collection";

export default class Keywords extends Collection {
  get model() {
    return Keyword;
  }

  stats() {
    this.trimAllNames();
    const nonBlank = _.reject(this.models, key => $.trim(key.get('name')) === '');
    const unique = _.unique(_.map(nonBlank, key => JSON.stringify(key)));
    return {
      unique,
      allUnique: (nonBlank.length === unique.length)
    };
  }

  invalidPhrases() {
    return _.filter(this.pluck('name'), key => /[|]/.test(key));
  }

  allPhrases() {
    const keywords = _.reject(this.models, keyObj => $.trim(keyObj.get('name')) === '');
    return keywords.map(keyObj => {
      const name = $.trim(keyObj.get('name'));
      const speaker = (keyObj.get('speaker') !== "Agent or Caller") ? `|${keyObj.get('speaker')}` : '';
      return name + speaker;
    });
  }

  trimAllNames() {
    _.each(this.models, key => {
      key.trimName();
    });
  }

  formattedList() {
    const keywords = _.reject(this.models, keyObj => $.trim(keyObj.get('name')) === '');
    return keywords.map(keyObj => {
      const name = $.trim(keyObj.get('name'));
      const speaker = ` (${keyObj.get('speaker')})`;
      return name + speaker;
    });
  }
}
